// 校验规则

export const rulesRequired = (message = '必填项', trigger = ['change', 'blur']) => {
  return { required: true, message, trigger }
}

export const rulesPhone = (message = '手机号格式错误', trigger = ['change', 'blur']) => {
  return { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message, trigger }
}

export const rulesEmail = (message = '邮箱格式错误', trigger = ['change', 'blur']) => {
  return { type: 'email', message, trigger }
}

export const rulesIDCard = (message = '格式不正确', trigger = ['change', 'blur']) => {
  return { pattern: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/, message, trigger }
}

export const rulesPattern = (regExp, message = '格式不正确', trigger = ['change', 'blur']) => {
  return { pattern: regExp, message, trigger }
}



// WEBPACK FOOTER //
// ./src/assets/js/validate.js